export var CustomerCode;

(function (CustomerCode) {
  CustomerCode["RESI"] = "RESI";
  CustomerCode["SME"] = "SME";
})(CustomerCode || (CustomerCode = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jdXN0b21lckNvZGUudHMiXSwibmFtZXMiOlsiQ3VzdG9tZXJDb2RlIl0sIm1hcHBpbmdzIjoiQUFBQSxXQUFZQSxZQUFaOztXQUFZQSxZO0FBQUFBLEVBQUFBLFk7QUFBQUEsRUFBQUEsWTtHQUFBQSxZLEtBQUFBLFkiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBDdXN0b21lckNvZGUge1xuICBSRVNJID0gXCJSRVNJXCIsXG4gIFNNRSA9IFwiU01FXCJcbn1cbiJdfQ==